import { useCallback } from 'react';
import { FeatureFlagName } from '@diritto/common/system/constants';
import { useGetFeatureFlagConfigsQuery } from 'queries/system/useGetFeatureFlagConfigsQuery';

export const useFeatureFlagConfig = () => {
  const { data } = useGetFeatureFlagConfigsQuery();
  const isActiveFlag = useCallback((flag: FeatureFlagName) => !!data?.featureFlagConfigs?.[flag]?.isActive, [data]);
  const getFlagExtraInfo = useCallback((flag: FeatureFlagName) => data?.featureFlagConfigs?.[flag]?.extraInfo, [data]);

  return { isActiveFlag, getFlagExtraInfo, featureFlagConfigs: data?.featureFlagConfigs };
};
